import { Action, createReducer, on } from '@ngrx/store';
import { ProfileActions } from './profile.actions';
import { profileInitialState, ProfileState } from './profile.state';

const _profileReducer = createReducer(
  profileInitialState(),
  /**
   * Reducers For Update Email
   */
  on(ProfileActions.updateProfileData, (state) => {
    return {
      ...state,
      updateProfileData: {
        loading: true,
      },
    };
  }),
  on(ProfileActions.updateProfileDataSuccess, (state, { response }) => {
    return {
      ...state,
      updateProfileData: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(ProfileActions.updateProfileDataFailure, (state, { failure }) => {
    return {
      ...state,
      updateProfileData: {
        loading: false,
        failure: failure,
      },
    };
  }),
  /**
   * Reducers For Update Password
   */
  on(ProfileActions.updatePassword, (state) => {
    return {
      ...state,
      updatePassword: {
        loading: true,
      },
    };
  }),
  on(ProfileActions.updatePasswordSuccess, (state, { response }) => {
    return {
      ...state,
      updatePassword: {
        loading: false,
        data: true,
      },
    };
  }),
  on(ProfileActions.updatePasswordFailure, (state, { failure }) => {
    return {
      ...state,
      updatePassword: {
        loading: false,
        failure: failure,
      },
    };
  }),

  /**
   * Reducers For Update Photo
   */
  on(ProfileActions.updatePhoto, (state) => {
    return {
      ...state,
      updatePhoto: {
        loading: true,
      },
    };
  }),
  on(ProfileActions.updatePhotoSuccess, (state, { response }) => {
    return {
      ...state,
      updatePhoto: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(ProfileActions.updatePhotoFailure, (state, { failure }) => {
    return {
      ...state,
      updatePhoto: {
        loading: false,
        failure: failure,
      },
    };
  })
);

export function profileReducer(
  state: ProfileState | undefined,
  action: Action
) {
  return _profileReducer(state, action);
}
